import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './MainLayout.module.css';
import Breadcrumb from '../../components/Breadcrumb';
import Nav from '../nav';
import { useNavigation } from '../../context/NavigationContext ';

function MainLayout() {
  const { currentTitle } = useNavigation();

  return (
    <div className={styles.layout}>
      <Nav />
      <div className={styles.content}>
        <div className={styles.breadcrumb}>
          <Breadcrumb />
        </div>
        <div className={styles.pageTitle}>
          {currentTitle}
        </div>
        <Outlet />
      </div>
    </div>
  );
}

export default MainLayout;